import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent, useCssModule } from "vue";
export default defineComponent({
  setup(props, ctx) {
    const css = useCssModule("css");
    return () => _createVNode("div", {
      "class": [css.empty, "empty_data_show"]
    }, [_createVNode("img", {
      "class": css.img,
      "src": "http://yuou-server-test.oss-cn-hangzhou.aliyuncs.com/USER/2022/8/31/630efc45e4b0431cc69cd3eb.png"
    }, null), _createVNode("span", {
      "class": css.text
    }, [_createTextVNode("\u6682\u65E0\u6570\u636E")])]);
  }
});